import { render, staticRenderFns } from "./GoldsettingSpot.vue?vue&type=template&id=75ac51c9&scoped=true"
import script from "./GoldsettingSpot.vue?vue&type=script&lang=js"
export * from "./GoldsettingSpot.vue?vue&type=script&lang=js"
import style0 from "./GoldsettingSpot.vue?vue&type=style&index=0&id=75ac51c9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ac51c9",
  null
  
)

export default component.exports